import React, {useState, useEffect, useContext} from 'react';
import {loadModules} from 'esri-loader';
import Button, { ButtonGroup } from 'calcite-react/Button';
import Form, { FormControl, FormControlLabel } from 'calcite-react/Form'; 
import Select from 'calcite-react/Select';
import Switch from 'calcite-react/Switch';
import Menu, { MenuTitle, MenuItem } from 'calcite-react/Menu';
import MeasureLineIcon from 'calcite-ui-icons-react/MeasureLineIcon';
import MeasureAreaIcon from 'calcite-ui-icons-react/MeasureAreaIcon';
import TrashIcon from 'calcite-ui-icons-react/TrashIcon';
import Mapstore from '../MapStore';

const Filter = ({view}) => {
    const nodeRef = React.createRef(); //
    const [selected, setSelected] = useState({layerName: null, layer: null, fieldName: null, fieldValue: null, uniqueFieldValues: [], expression: null, check: false});
    const store = useContext(Mapstore);

    let measurement;

    const expressionLookup = {
        'is': '=',
        'is not': '<>',
        'is blank': 'IS NULL',
        'is not blank': 'IS NOT NULL'
    }

    const selectLayerHandler = ((value, item) => {
        console.log("layer");
        const foundLayer = view.map.layers.find(function(layer) {
            return layer.title === value;
        });
        setSelected({...selected, layerName: value, layer: foundLayer}); 
    });

    const selectFieldHandler = ((value, item) => {
        console.log("field");
        selected.layer.supportsAdvancedQueries = true;
        let query = selected.layer.createQuery();

        query.returnGeometry = false;
        query.outFields = [value];
        query.returnDistinctValues = true;
        let uniqueFieldValues = [];
        selected.layer.queryFeatures(query).then(function(response){
            let features = response.features;
            features.forEach(feature => {
                uniqueFieldValues.push(feature.attributes[value])
            });
            setSelected({...selected, fieldName: value, uniqueFieldValues: uniqueFieldValues}); 
        });
    });

    const selectExpressionHandler = ((value, item) => {
        console.log("expression");
        setSelected({...selected, expression: value}); 
    });

    const selectSwitchHandler = ((value) => {
        console.log("switch");
        setSelected({...selected, check: value.target.checked}); 
        if (selected.fieldValue && value.target.checked) {
            view.whenLayerView(selected.layer).then(function(layerView) {
                const expr = expressionLookup[selected.expression];
                layerView.filter = {
                    where: selected.fieldName + " " + expr + " '" + selected.fieldValue + "'"
                }
            });
        } else if (value.target.checked === false) {
            view.whenLayerView(selected.layer).then(function(layerView) {
                layerView.filter = {
                    where: "1 = 1" // always true
                }
            });
        }
    });

    const selectValueHandler = ((value) => {
        console.log("value");
        setSelected({...selected, fieldValue: value}); 
        if (selected.check) {
            view.whenLayerView(selected.layer).then(function(layerView){
                layerView.filter = {
                    where: selected.fieldName + " " + expressionLookup[selected.expression] + " '" + value + "'"
                }
            });
        }
    });
    
    useEffect(() => {
        const runEffect = async () => {
            loadModules(['esri/layers/FeatureLayer'], {css: true}).then(([FeatureLayer]) => {
                if (view.layerViews.length > 0){
                    view.layerViews.forEach((layerView) => {
                        //console.log(layerView.layer.title);

                    });
                }
            }).catch((err) => console.error(err));  
        }
        runEffect();
        return () => {
            if (!!store.measurement) {
                console.log('closed');
                store.measurement.container = null;
            }
        }
    }, [nodeRef.current]);

    // useEffect(() => {
    //     if (store.measurement) {
    //         if (selected === 1) {
    //             store.measurement.activeTool = 'distance';
    //         } else if (selected === 2) {
    //             store.measurement.activeTool = 'area';
    //         } else {
    //             store.measurement.clear();
    //         }
    //     }
    // }, [selected]);

    return (
        <React.Fragment>
            <div id='filter' ref={nodeRef}>
                <Form>
                <FormControl>
                    <Switch fullWidth labelPosition="before" checked={selected.check} onChange={selectSwitchHandler}>Apply Filter</Switch>
                </FormControl>
                <FormControl>
                    <FormControlLabel>Layer:</FormControlLabel>
                    <Select fullWidth onChange={selectLayerHandler} selectedValue={selected.layerName}>
                        { view.layerViews.items.map((layerView, index) => {
                            return (
                                <MenuItem key={index} value={layerView.layer.title}>
                                    {layerView.layer.title}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <FormControl>
                    <FormControlLabel>Field:</FormControlLabel>
                    <Select fullWidth disabled={selected.layerName === null } onChange={selectFieldHandler} selectedValue={selected.fieldName}>
                        { selected.layer === null ? null : selected.layer.fields.map((field, index) => {
                            return (
                                <MenuItem key={index} value={field.name}>
                                    {field.name}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <FormControl>
                    <FormControlLabel>Expression:</FormControlLabel>
                    <Select fullWidth onChange={selectExpressionHandler} selectedValue={selected.expression}>
                        <MenuItem key={0} value='is'>is</MenuItem>
                        <MenuItem key={1} value='is not'>is not</MenuItem>
                        <MenuItem key={2} value='is blank'>is blank</MenuItem>
                        <MenuItem key={3} value='is not blank'>is not blank</MenuItem>
                    </Select>
                </FormControl>
                <FormControl>
                    <FormControlLabel>Value:</FormControlLabel>
                    <Select fullWidth disabled={selected.fieldName === null } onChange={selectValueHandler} selectedValue={selected.fieldValue}>
                        { selected.uniqueFieldValues.length < 1 ? null : selected.uniqueFieldValues.map((value1, index) => {
                            return (
                                <MenuItem key={index} value={value1}>
                                    {value1}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                </Form>
            </div>
            <div id='info'></div>
        </React.Fragment>
    )  
}

export { Filter };